import React, { useRef } from "react";
import "./LatestBlogsSection.css";
import { useNavigate } from "react-router-dom";

import {
  FaChevronLeft,
  FaChevronRight,
  FaArrowRight
} from "react-icons/fa";

const blogs = [
  {
    id: 1,
    slug: "how-to-find-trusted-service-providers-near-you",
    category: "Local Services",
    title: "How to Find Trusted Service Providers Near You",
    image: "/blog1.png",
  },
  {
    id: 2,
    slug: "benefits-of-using-a-private-communication-id",
    category: "Communication",
    title: "Benefits of Using a Private Communication ID",
    image: "/blog2.png",
  },
  {
    id: 3,
    slug: "why-every-local-business-needs-a-digital-presence",
    category: "Business",
    title: "Why Every Local Business Needs a Digital Presence",
    image: "/blog3.png",
  },
  {
    id: 4,
    slug: "privacy-first-communication-the-future-of-digital-connections",
    category: "Technology",
    title: "Privacy-First Communication: The Future of Digital Connections",
    image: "/blog4.png",
  },
  {
    id: 5,
    slug: "why-you-shouldnt-share-your-personal-phone-number-online",
    category: "Privacy",
    title: "Why You Shouldn't Share Your Personal Phone Number Online",
    image: "/blog5.png",
  }
];

export default function LatestBlogsSection() {
const navigate = useNavigate();
  const sliderRef = useRef();
  

  const scroll = (dir) => {
    sliderRef.current.scrollBy({
      left: dir === "left" ? -350 : 350,
      behavior: "smooth"
    });
  };

  return (
    <section className="blog-section">

      <div className="blog-header">

        <div>
          <span className="blog-subtitle">
            Latest Articles
          </span>

          <h2 className="blackcolor">
            Learn, Explore &
            <span> Grow</span>
          </h2>
        </div>

        <div className="blog-nav">

          <button onClick={() => scroll("left")}>
            <FaChevronLeft />
          </button>

          <button onClick={() => scroll("right")}>
            <FaChevronRight />
          </button>

        </div>

      </div>

      <div
        className="blog-slider"
        ref={sliderRef}
      >

    {blogs.map(blog => (
        <div className="blog-card" key={blog.id}>

          <div className="blog-image">
            <img src={blog.image} alt={blog.title} />
          </div>

          <div className="blog-body">

            <h3>{blog.title}</h3>

            <button
              onClick={() => navigate(`/blog/${blog.slug}`)}
            >
              Read Article <FaArrowRight />
            </button>

          </div>

        </div>
      ))}

      </div>

    </section>
  );

}